import { useQuery } from "@tanstack/react-query";

export const useCmsPageQuery = () => {
  return useQuery({
    queryKey: ["cms-page-store"],
    queryFn: async () => {
      return fetch(`${__PATH_PREFIX__}/cms-page-store.json`).then((response) => response.json());
    },
    enabled: false,
    retry: false,
    staleTime: Infinity,
  });
};
